<template>
  <div class="space-top-sm">
    <a
      :style="`background-color: rgba(${settings.bgColorRGBA}); color: rgba(${settings.fontColorRGBA});`"
      :href="link.href"
      target="_system"
      class="conversation--link"
    >
      {{ link.label }}
    </a>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      link: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapGetters(['settings'])
    }
  }
</script>

<style>
  .conversation--link {
    border-radius: 8px;
    padding: 0.5rem;
    cursor: pointer;
    text-decoration: none !important;
  }

  .conversation--link:hover {
    opacity: 0.8;
  }
</style>
